import React, { useRef } from "react";
import { useFormik } from "formik";
import InputField from "../../../Components/InputField";
import Flatpickr from "react-flatpickr";
import SelectField from "../../../Components/SelectField";
import DateField from "../../../Components/DateField";
import { default as ReactSelect, components } from "react-select";
import ReactSelectField from "../../../Components/ReactSelectField";

let dateformat: object = { dateFormat: "m-d-Y", altFormat: "M-d-Y" };
const statusList = [
  { label: "Done", value: "DONE" },
  { label: "In Progress", value: "IN_PROGRESS" },
  { label: "Closed", value: "CLOSED" },
];

const FilterGridData = ({onSearch}: any) => {
  const stDateRef = useRef<Flatpickr>(null);
  const endDateRef = useRef<Flatpickr>(null);

  const formik = useFormik({
    initialValues: {
      documentCode: "",
      startDate: "",
      endDate: "",
      unitNumber: "",
      vinNumber: "",
      status: [],
    },
    onSubmit: (values, {resetForm}) => {
      const { status, ...rest } = values;

      const queryParams = Object.entries(rest)
        .filter(([_, value]) => value !== "" && value !== null && value !== undefined)
        .map(([key, value]: any) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(
            value instanceof Date
            ? `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`
            : value
          )}`
        )
        .join("&");

      let queryString = queryParams;
      if (status && Array.isArray(status) && status.length > 0) {
        const statusValues = status.map((item: any) => item.value).join(",");
        queryString += (queryString ? "&" : "") + `status=${encodeURIComponent(statusValues)}`;
      }
      onSearch(queryString);
      // resetForm();
    },
  });

  return (
    <div
      className="mx-1 card"
      style={{
        padding: "20px 5px",
      }}
    >
      <form onSubmit={formik.handleSubmit} className='new-interchange'>
        <div className="row d-flex align-items-center justify-content-around">
          <div className="row col-md-11 px-0 mx-0">
            <div className="col-2">
              <InputField
                type="text"
                name="documentCode"
                placeholder="Document Code"
                value={formik.values.documentCode}
                onChange={formik.handleChange}
              />
            </div>
            <div className="col-2">
              <DateField
                placeholder="Start Date"
                ref={stDateRef}
                onChange={([start]: any) => {
                  formik.setFieldValue("startDate", start);

                  if (endDateRef.current?.flatpickr) {
                    endDateRef.current.flatpickr.set("minDate", start);
                  }
                }}
                options={{
                  ...dateformat,
                }}
                value={formik.values.startDate}
              />

            </div>
            <div className="col-2">
              <DateField
                placeholder="End Date"
                ref={endDateRef}
                onChange={([date]: any) => {
                  formik.setFieldValue("endDate", date);
                }}
                options={{
                  ...dateformat,
                  minDate: formik.values.startDate || null,
                }}
                value={formik.values.endDate}
              />

            </div>
            <div className="col-2">
              <InputField
                type="text"
                name="unitNumber"
                placeholder="Unit Number"
                value={formik.values.unitNumber}
                onChange={formik.handleChange}
              />
            </div>
            <div className="col-2">
              <InputField
                type="text"
                name="vinNumber"
                placeholder="Vin Number"
                value={formik.values.vinNumber}
                onChange={formik.handleChange}
              />
            </div>
            <div className="col-2">
              <ReactSelectField
                name="status"
                placeholder="Status"
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
                options={[...statusList]}
                value={formik.values.status}
                onChange={(selected:any) => formik.setFieldValue("status", selected)}
              />
            </div>
          </div>
          <div className="row ps-1 col-md-1">
            <div className="col-12 px-0">
              <button type="submit" className="btn btn-primary col-11">Search</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

const CustomMultiValue = ({ data, index, selectProps }: any) => {
  const selectedValues = selectProps.value || [];
  if (index !== 0) return null;

  const visibleCount = 3;
  const visibleLabels = selectedValues.slice(0, visibleCount).map((item: any) => item.label);
  const remainingCount = selectedValues.length - visibleCount;

  return (
    <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
      <span>{visibleLabels.join(",  ")}</span>
      {remainingCount > 0 && (
        <span className="count-badge" style={{ marginLeft: 5 }}>
          +{remainingCount}
        </span>
      )}
    </div>
  );
};


const CustomOption = (props: any) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
      />
      <label style={{ marginLeft: "8px" }}>{props.label}</label>
    </components.Option>
  );
};
export default FilterGridData;